module.exports = __webpack_public_path__ + "img/icon-peoplepower.93322e31.png";